import React from 'react';

function LoadingScreen() {
    return (
        <>
            <div>
                <div className="loadingScreen">
                    <div className="spinner"></div>
                </div>
            </div>
        </>
    )
}

export default LoadingScreen;